import { NotificationAdd } from "@mui/icons-material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { Badge, Box, styled, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import axios from "axios";
import Cookies from "js-cookie";
import * as React from "react";
import Notifications from "./Notifications";

export default function PositionedMenu({
  notifications,
  setBadgeContent,
  badgeContent,
  setNotifications,
}) {
  const [noti, setNoti] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    console.log("Abid");
    setAnchorEl(event.currentTarget);

    axios
      .post(
        `${process.env.React_APP_BACKEND_URL}/api/setnoti`,
        {
          totaNoti: 0,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      )
      .then((res) => {
        setBadgeContent(0);
      })
      .catch((err) => console.log(err));
  };
  const handleClose = () => {
    setBadgeContent(0);
    setAnchorEl(null);
  };
  const removeNotification = (notificationId, serverBadgeCount) => {
    setNotifications((current) => current.filter((item) => item.id !== notificationId));
    if (Number.isFinite(Number(serverBadgeCount))) {
      setBadgeContent(Number(serverBadgeCount));
    } else {
      setBadgeContent((current) => Math.max(0, current - 1));
    }
  };
  const FlexBox = styled(Box)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontFamily: `${process.env.REACT_APP_FONT}`,

    justifyContent: "space-between",
  });
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 44,
        height: 44,
        flexShrink: 0,
        fontFamily: `${process.env.REACT_APP_FONT}`,
      }}
    >
      <Button
        id="demo-positioned-button"
        aria-label="התראות"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{
          minWidth: 44,
          width: 44,
          height: 44,
          p: 0,
          borderRadius: "14px",
          color: "#1677D2",
          backgroundColor: "rgba(255,255,255,.96)",
          border: "1px solid rgba(255,255,255,.72)",
          boxShadow: "0 8px 22px rgba(0,48,96,.20)",
          transition:
            "transform .18s ease, box-shadow .18s ease, background-color .18s ease",
          "&:hover": {
            backgroundColor: "#FFFFFF",
            transform: "translateY(-1px)",
            boxShadow: "0 11px 26px rgba(0,48,96,.25)",
          },
          "&:active": { transform: "scale(.96)" },
        }}
      >
        <Badge
          badgeContent={badgeContent}
          max={99}
          color="error"
          overlap="circular"
          sx={{
            cursor: "pointer",
            "& .MuiBadge-badge": {
              minWidth: 18,
              height: 18,
              px: 0.5,
              fontSize: "10px",
              fontWeight: 800,
              border: "2px solid #FFFFFF",
              boxShadow: "0 2px 7px rgba(211,47,47,.28)",
            },
          }}
        >
          <NotificationAdd sx={{ fontSize: 23 }} />
        </Badge>
      </Button>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            mt: 1.2,
            width: { xs: "calc(100vw - 24px)", sm: 390 },
            maxWidth: 390,
            maxHeight: "min(560px, 72vh)",
            borderRadius: "18px",
            border: "1px solid rgba(20,79,132,.10)",
            boxShadow: "0 22px 60px rgba(15,55,90,.22)",
            overflow: "auto",
            "& .MuiMenu-list": { p: 0 },
          },
        }}
      >
        <Box
          sx={{
            fontFamily: `${process.env.REACT_APP_FONT}`,
            verticalAlign: "center",
            p: 1.5,
          }}
        >
          <FlexBox
            sx={{
              width: "100%",
              justifyContent: "flex-start",
              gap: 1.2,
              p: 1.2,
              mb: 1,
              borderRadius: "14px",
              background:
                "linear-gradient(135deg, rgba(51,153,255,.12), rgba(250,175,60,.12))",
            }}
          >
            <Box
              sx={{
                width: 38,
                height: 38,
                borderRadius: "12px",
                display: "grid",
                placeItems: "center",
                color: "#1677D2",
                backgroundColor: "#FFFFFF",
                boxShadow: "0 6px 16px rgba(22,119,210,.13)",
              }}
            >
              <NotificationsIcon sx={{ fontSize: 22 }} />
            </Box>
            <Box>
              <Typography
                variant="h6"
                sx={{
                  fontFamily: `${process.env.REACT_APP_FONT}`,
                  fontWeight: 800,
                  fontSize: "17px",
                  lineHeight: 1.2,
                  color: "#123A5C",
                }}
              >
                התראות
              </Typography>
              <Typography
                sx={{
                  fontFamily: `${process.env.REACT_APP_FONT}`,
                  fontSize: "12px",
                  color: "#668096",
                  mt: 0.25,
                }}
              >
                העדכונים האחרונים בחשבון שלך
              </Typography>
            </Box>
          </FlexBox>
          {notifications.length > 0 ? (
            [...notifications]
              .reverse()
              .map((notification) => (
                <Notifications
                  key={notification.id}
                  handleClose={handleClose}
                  notification={notification}
                  removeNotification={removeNotification}
                />
              ))
          ) : (
            <Box
              sx={{
                textAlign: "center",
                py: 4,
                px: 2,
                borderRadius: "14px",
                backgroundColor: "#F7FAFD",
              }}
            >
              <NotificationsIcon
                sx={{ fontSize: 34, color: "#A9BBCB", mb: 1 }}
              />
              <Typography
                sx={{
                  fontFamily: `${process.env.REACT_APP_FONT}`,
                  fontWeight: 700,
                  color: "#49677F",
                }}
              >
                אין לך התראות חדשות
              </Typography>
            </Box>
          )}
        </Box>
      </Menu>
    </Box>
  );
}
